import React, { useEffect, useState } from "react";
import TableDigiUpload from "./TableDigiUpload";
import MannualUpload from "./mannualUpload";
import ViewDoc from "../../assets/img/eye-icon-black.svg";
import DownloadDoc from "../../assets/img/download-icon-black.svg";
import EditDoc from "../../assets/img/penEditDarkGrey.png";
import UploadBox from "../../assets/img/File-upload-box-blue.svg";
import DocumentIcon from "../../assets/img/DocumentTypeIcon.svg";
import closeIcon from "../../assets/img/close-Dark-Icon.svg";
import { getDigiResponse, saveDigiReasonApi } from "../../Actions/DigiLockerActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../Common/loader";
import { toast } from "react-toastify";

function UploadDIgiDocs() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storeData = useSelector((state) => state.digiLockerData);
  const digiData = storeData?.digiLocakerData?.data
  const allcaseCheckIds = digiData?.non_digilocker_docs?.map(item => item.check_id);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [reason, setReason] = useState('');
  const [uploadDocsLater, setUploadDocsLater] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [mandatoryDocs, setMandatoryDocs] = useState([])
  const [uploadedDocs, setuploadedDocs] = useState([])
  const [errorDocs, seterrorDocs] = useState([])
  // const [allChecks, setAllChecks] = useState([])

  // Define a function to handle changes in the dropdown
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleReason = (event) => {
    console.log(event.target.value);
    setReason(event.target.value);
  };
  const options = {
    1:"My mobile no. is not linked with my Aadhaar",
    2:"Unable to fetch my documents after retry",
    3:"I do not wish to fetch documents from DigiLocker",
    4:"Other"
  }
  useEffect(() => {
    localStorage.setItem("disableEditDigi", true);
    setIsLoading(true)
    dispatch(
      getDigiResponse()
    );

    console.log(digiData)
    
  },[])
  useEffect(() => {
    setIsLoading(true)
  })
  useEffect(() => {
    

if(storeData?.loading!=null && storeData?.loading!= undefined &&storeData?.loading==false){
  setIsLoading(false)
}
// if(digiData)
//     {const caseCheckIds = digiData?.non_digilocker_docs
//   .filter(item => item.document_checkbox == "1")
//   .map(item => item.case_check_id);
//   // const allcaseCheckIds = digiData?.non_digilocker_docs?.map(item => item.check_id);
//   setUploadDocsLater(caseCheckIds)
//   // setAllChecks(allcaseCheckIds)
// }
    
  })
  useEffect(()=>{
    if(digiData)
    {const caseCheckIds = digiData?.non_digilocker_docs
  .filter(item => item.document_checkbox == "1")
  .map(item => item.case_check_id);
  // const allcaseCheckIds = digiData?.non_digilocker_docs?.map(item => item.check_id);
  setUploadDocsLater(caseCheckIds)}
  },[digiData])

  useEffect(() => {
    if (showSubmitPopup) {
      // Disable scrolling on the body when the modal is open
      document.body.classList.add('modal-open');
    } else {
      // Enable scrolling on the body when the modal is closed
      document.body.classList.remove('modal-open');
    }
  }, [showSubmitPopup]);

  const saveCallback=(data) =>{
    // setShowSubmitPopup(false);
    console.log(data);
    const group = data?.group
        ? data?.group?.group_id
        : "";
      const hasNextCheck = data?.nextCheck != "" ? true : false;
      const reference = data?.reference_number;
    if (!hasNextCheck) {
      if (group == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${reference}`);
        // dispatch(deleteSaveEducation());
      } else if (typeof group != "undefined" && group != "") {
        navigate(`/case-initiation/check-detail/${reference}/${group}`);
        // dispatch(deleteSaveEducation());
      }
    } else {
      navigate(
        `/case-initiation/check-detail/${reference}/3/${data?.nextCheck}`
      );
  }}

  const handleSubmit = ()=>{debugger
    const updatedValues = new Set([...mandatoryDocs]);
    const mandatoryDocsArray = Array.from(updatedValues);
    for (let i = mandatoryDocsArray.length - 1; i >= 0; i--) {
      // Check if any prefix matches the start of the element
      for (let j = 0; j < uploadDocsLater?.length; j++) {
          if (mandatoryDocsArray[i].startsWith(uploadDocsLater[j])) {
              // Remove the element if it starts with any prefix
              mandatoryDocsArray.splice(i, 1);
              break; // Move to the next element
          }
      }
  }
    if(mandatoryDocsArray.every(element => uploadedDocs.includes(element)))
    {if(storeData?.digiLocakerData?.collect_document==0)
    {setShowSubmitPopup(true);}
    else{
      //call the submit api
      let payload={}
      payload.upload_docs_later=uploadDocsLater
      payload.initial_case_id=storeData?.digiLocakerData?.initial_case_id
      //debugger
      dispatch(
        saveDigiReasonApi(payload,saveCallback)
      );
    }}
    else{
      
      const filteredArray = mandatoryDocsArray.filter((element) => !uploadedDocs.includes(element));
      seterrorDocs(filteredArray)
      toast.error("Please upload mandatory documents", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
      );

    }
  }

  const handleSaveReason = () =>{
    if(selectedOption=='')
    {
      toast.error("Please select a reason", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
      );
    }
    else
    {setShowSubmitPopup(false);
    //call the submit api
    let payload={}
    payload.initial_case_id=storeData?.digiLocakerData?.initial_case_id
    if(selectedOption=="Other"){
      payload.digilocker_reason = reason;
    }
    else{
      payload.digilocker_reason = selectedOption
    }
    dispatch(
      saveDigiReasonApi(payload,saveCallback)
    );}
  }

  const handleCancel = () =>{
    setSelectedOption('');
    setReason('')
    setShowSubmitPopup(false);
  }
  console.log(errorDocs)
  
  return (
    <>
    {isLoading && <Loader />}
      <div
        className="container-fluid row m-0 p-3"
        style={{ background: "#F9FAFB" }}
      >
        {!!digiData?.fetched_docs.length && <><h2 className="eduHeading col-12 pb-4">
          Upload documents via Digilocker
        </h2>
        <div className="col-12 w-100" style={{ overflowY: "hidden" }}>
        <TableDigiUpload
          headers={[
            "Course Name",
            "University/Board",
            "Year of Passing",
            "Document Type",
            "Action",
          ]}
          data={digiData?.fetched_docs}
          // data={[
          //   [
          //     "1Senior Sec (12th)",
          //     "CBSE",
          //     "9876543210",
          //     "2010",
          //     "Marksheet",
          //     <div className="d-flex justify-content-start align-content-center">
          //       <span>
          //         <img
          //           style={{ cursor: "pointer" }}
          //           src={ViewDoc}
          //           alt="ViewDoc"
          //         />
          //       </span>{" "}
          //       &nbsp; &nbsp;
          //       <span>
          //         <img
          //           style={{ cursor: "pointer" }}
          //           src={DownloadDoc}
          //           alt="DownloadDoc"
          //         />
          //       </span>
          //     </div>,
          //   ],
          //   [
          //     "1Senior Sec (12th)",
          //     "CBSE",
          //     "9876543210",
          //     "2010",
          //     "Marksheet",
          //     <div className="d-flex justify-content-start align-content-center">
          //       <span>
          //         <img
          //           style={{ cursor: "pointer" }}
          //           src={ViewDoc}
          //           alt="ViewDoc"
          //         />
          //       </span>{" "}
          //       &nbsp; &nbsp;
          //       <span>
          //         <img
          //           style={{ cursor: "pointer" }}
          //           src={DownloadDoc}
          //           alt="DownloadDoc"
          //         />
          //       </span>
          //     </div>,
          //   ],
          // ]}
          type="fetched"
        /></div></>}

        {!!digiData?.non_fetched_docs.length &&<><div className="headings col-12 pb-4">
          <h2 className="eduHeading">Not Available on Digilocker</h2>
          <div className="subHead">
          Review your information and retry with correct information by clicking on ‘Edit Details & Retry’ if required
          </div>
        </div>
        <div className="col-12 w-100" style={{ overflowY: "hidden" }}>
        <TableDigiUpload
          headers={[
            "Course Name",
            "University/Board",
            "Year of Passing",
            "Document Type",
          ]}
          data={digiData?.non_fetched_docs}
          // data={[
          //   [
          //     "1Senior Sec (12th)",
          //     "CBSE",
          //     "9876543210",
          //     "2010",
          //     <div className="text-danger">
          //       Not Available<sup>*</sup>
          //     </div>,
          //     " ",
          //   ],
          //   [
          //     "1Senior Sec (12th)",
          //     "CBSE",
          //     "9876543210",
          //     "2010",
          //     <div className="text-danger">
          //       Not Available<sup>*</sup>
          //     </div>,
          //     " ",
          //   ],
          // ]}
          type="notfetched"
        />
        </div>

        <div className="headings col-12 pb-4 pt-0">
          <div className="subHead">
            <sup>*</sup> This will not affect your verification journey
          </div>
        </div></>}

       {
        !!digiData?.non_digilocker_docs.length && 
       <><div className="headings col-12 pb-4">
          <h2 className="eduHeading">Upload Required Documents</h2>
          <div className="subHead">
          Document not available on digilocker. Please upload manually
          </div>
          
        </div>
        {digiData?.non_digilocker_docs.map((mannualEduData)=>
          (<MannualUpload data={mannualEduData} errorDocs={errorDocs} uploadedDocs={uploadedDocs} setUploadedDocs={setuploadedDocs} mandatoryDocs={mandatoryDocs} setMandatoryDocs={setMandatoryDocs} submitLater={storeData?.digiLocakerData?.upload_docs_later_checkbox} uploadDocsLater={uploadDocsLater} setUploadDocsLater={setUploadDocsLater} allChecks={allcaseCheckIds}/>)
        )}
        </>}
        

        <div className="col-12 buttons d-flex justify-content-start align-items-center">
          {/* <div className="btn btn-white text-dark">Back</div> */}
          <div
            className="btn btn-primary ml-2"
            onClick={handleSubmit}
            type="button"
            
            // 
          >
            Continue
          </div>

          {/* Modal */}
          
        </div>
        {/* {!showSubmitPopup&&<div
            // className="modal"
            id="SubmitPopUp"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            style={{position:"absolute",
                    top:"0%",
                    left:"29%"}}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-bottom-0">
                  <h4 className="modal-title" id="staticBackdropLabel">
                    Submit without documents
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={handleCancel}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="subHead">
                    Documents are not fetched for ‘count’ education(s). If you
                    wish to submit anyway, please select the reason.
                  </p>
                  <h5>Select Reason</h5>

                  <div className="btn-group pb-3">
                  <select value={selectedOption} onChange={handleSelectChange} className="btn btn-white dropdown-toggle">
                    {Object.values(options).map((value,key)=>{
                      return(<option className="dropdown-item" value={value}>{value}</option>)
                    })}
      </select>
        
                  </div>
                  <form>
                    {selectedOption=="Other" &&<div className="form-group">
                      <textarea
                        className="form-control"
                        placeholder="Add Reason"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        onChange={handleReason}
                      ></textarea>
                    </div>}
                  </form>
                </div>
                <div className="modal-footer justify-content-start border-top-0">
                  <button
                    type="button"
                    className="btn btn-white text-dark"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </div></div>
          } */}
        {showSubmitPopup && (
        <div className="modal fade show" tabIndex="-1" data-backdrop="static" role="dialog" aria-hidden="true" style={{ display: 'block', backgroundColor: "rgba(0, 0, 0, 0.1)", backdropFilter: "blur(1px)", }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)", }}>
              <div className="modal-header border-bottom-0">
              <h4 className="modal-title" id="staticBackdropLabel">
                    Submit without documents
                  </h4>
                <button type="button" className="close" onClick={handleCancel}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body py-0">
                  <p className="subHead" style={{ textAlign: "justify", }}>
                    Documents are not fetched for education(s). If you
                    wish to submit anyway, please select the reason.
                  </p>
                  <h5>Select Reason</h5>

                  <div className="btn-group pb-3 w-100">
                  <select value={selectedOption} onChange={handleSelectChange} className="btn btn-white dropdown-toggle text-left w-100">
                    <option disabled value="" className="dropdown-item disabled">Select Your Reason</option>
                    {Object.values(options).map((value,key)=>{
                      return(<option className="dropdown-item w-100" value={value}>{value}</option>)
                    })}
                  </select>
        
                  </div>
                  <form>
                    {selectedOption=="Other" &&<div className="form-group">
                      <textarea
                        className="form-control"
                        placeholder="Add Reason"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        onChange={handleReason}
                      ></textarea>
                    </div>}
                  </form>
                </div>
                <div className="modal-footer justify-content-start border-top-0">
                  <button
                    type="button"
                    className="btn btn-white text-dark"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleSaveReason}>
                    Submit
                  </button>
                </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
}

export default UploadDIgiDocs